
<div class="card p-2 bg-white text-dark shadow-sm small w-100 border-0 rounded-3 task-card board-task-card" @click="open_task_modal(task, bucket)"
>
    <div class="d-flex justify-content-between gap-2">
    <div class="d-flex align-items-start mb-3 min-w-0 flex-grow-1">
        <input type="radio" class="form-check-input d-none" />
        <div class="task-card-title fs-xsm mt-1 mx-2">{{ task.name }}</div>

    </div>
   <i class="bi bi-three-dots dropdown-toggle"
   id="dropdownMenu2"
   data-bs-toggle="dropdown"
   aria-expanded="false"
   @click.stop>
</i>

      <ul
  ref="assignmenu"
  class="dropdown-menu dropdown-menu-start rounded-3 p-0 text-xs border-0 shadow-sm"
  aria-labelledby="dropdownMenu2"
  @click.stop>

  <!-- NEW: Move Task -->
  <li>
  <button
    class="dropdown-item"
    type="button"
    @click.stop="openMoveTaskModal(task)"
  >
    <i class="bi bi-arrow-left-right"></i> Move Task
  </button>
</li>

  <li>
    <button
      class="dropdown-item"
      type="button"
      @click.stop="delete_task(task.id)"
    >
      <i class="bi bi-trash3"></i> Delete
    </button>
  </li>
</ul>

  
      <div
        ref="assignDropdown"
        class="dropdown-menu px-1 shadow border-0 assignment-dropdown"
        :class="{ show: showAssignDropdown }"
        data-bs-auto-close="outside"
        @click.stop
      >
        <input
          type="text"
          class="form-control form-control-sm text-xxs rounded-3 border-0 border-bottom mb-2"
          placeholder="Type a name or email address"
          v-model="searchQuery"
        />
        <!-- show the assigned users -->
        <div v-if="filteredAssignees.length > 0">
        <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Assigned</div>
        <div
          v-for="member in filteredAssignees"
          :key="member.id"
          class="d-flex align-items-center px-2 py-1 dropdown-item position-relative"
          @click="assignUser(member.id,task.id)"
          style="overflow: hidden;"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center me-2 py-2 text-xxs text-white bg-primary w-20 h-20"
          >
            {{ getInitials(member.portal_access.base_profile_details?.creater?.first_name) }}{{ getInitials(member.portal_access.base_profile_details?.creater?.last_name) }}
          </div>
          <span class="text-dark small fs-xsm flex-grow-1">{{ member.portal_access.base_profile_details?.creater?.full_name }}</span>
          
          <i class="bi bi-x me-3" @click.stop.prevent="removeAssignedUser(member)"></i>
        </div>
        </div>
        
        <div class="fw-bold text-muted small px-1 mb-2 fs-xsm">Suggestions</div>

        <div
          v-for="member in filteredSuggestions"
          :key="member.id"
          class="d-flex align-items-center px-2 py-1 dropdown-item"
          @click="assignUser(member.id,task.id)"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center me-2 py-2 text-xxs text-white bg-primary w-20 h-20"
          >
            {{ getInitials(member.full_name) }}
          </div>
          <span class="text-dark small fs-xsm">{{ member.full_name }}</span>
        </div>
        <div v-if="filteredSuggestions.length === 0" class="text-muted small px-2 py-1 fs-xsm">
          No matches
        </div>
      </div>

    </div>
    <div class="task-chip-row d-flex gap-1 flex-wrap mb-1">
      <span v-for="tag in (task.tags || [])" :key="tag.id" class="task-chip task-chip-status" :style="tag_style(tag)">
        <i class="bi bi-tag-fill"></i> {{ tag.name }}
      </span>
      <span
        class="task-chip task-chip-priority"
        v-if="task.priority"
        :data-priority-tone="priority_tone(task.priority)"
      >
        <i class="bi bi-flag-fill"></i>
        {{ format_label(task.priority.priority_name) }}
      </span>
      <template v-if="task_progress_items(task).length">
        <span
          v-for="progress in task_progress_items(task)"
          :key="progress.id"
          class="task-chip task-chip-status"
          :class="status_chip_class(progress)"
        >
          <i class="bi bi-circle-fill"></i>
          {{ format_label(task_progress_name(progress)) }}
        </span>
      </template>

    </div>
<div class="d-flex justify-content-between fs-xsm">
    <div
      v-if="task.due_date"
      class="task-due-chip d-inline-flex align-items-center fw-500"
      :class="{
        'task-due-chip-overdue': new Date(task.due_date).setHours(0,0,0,0) < new Date().setHours(0,0,0,0)
      }"
    >
      <i class="bi bi-calendar3"></i>
      <span>{{ task.due_date }}</span>
    </div>
    <div class="d-flex">
      <div class="dropdown">
      <button
        type="button"
        class="btn btn-link p-0 rounded-circle d-flex justify-content-center text-xxs bg-primary text-white align-items-center  py-2 w-20 h-20"
        title="Assign"
        @click.stop.prevent="toggleAssignDropdown"
      >
        <i class="bi bi-person-plus-fill fs-xs"></i>
      </button>
      </div>
    <div v-for ="user in visibleAssignees"
      :key="user.id"
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary text-white align-items-center  py-2 ms-1 w-20 h-20"
    >

 {{ getInitials(user.portal_access.base_profile_details?.creater?.first_name) }}{{ getInitials(user.portal_access.base_profile_details?.creater?.last_name) }}
    </div>

    <button
      v-if="remainingAssigneeCount > 0"
      type="button"
      class="rounded-circle d-flex justify-content-center text-xxs bg-primary text-white align-items-center py-2 ms-1 w-20 h-20 border-0"
      :title="remainingAssigneesTitle"
    >
      +{{ remainingAssigneeCount }}
    </button>
         
    </div>
</div>

  </div>

<!-- Modal -->
<teleport to="body">
    <div
  class="modal fade"
  :id="'moveTaskModal-' + task.id"
  tabindex="-1"
  aria-labelledby="moveTaskModalLabel"
  aria-hidden="true"
  @click.stop>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded border-0 shadow-sm" @click.stop>
      <div class="modal-header bg-primary text-white position-relative">
        <p class="modal-title text-xxs fw-500" id="moveTaskModalLabel">Move Task</p>
        <button
          type="button"
          class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
          data-bs-dismiss="modal"
          aria-label="Close">
        </button>
      </div>

      <div class="modal-body">
        <select v-model.number="selectedColumnId" class="form-select">
          <option
            v-for="column in buckets"
            :key="column.id"
            :value="Number(column.id)"
          >
            {{ column.name  }}
          </option>
        </select>
      </div>

      <div class="modal-footer">
            <button class="btn btn-primary" @click="confirmMoveTask" :disabled="isMoving">
              <span v-if="!isMoving">Move</span>
              <span v-else>Moving...</span>
            </button>
          </div>
    </div>
  </div>
</div>
</teleport>
